import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { AnalyticsImageData } from '~types/index'

const onBannerClickInit = (clientId: string) => (data: AnalyticsImageData) => {
  trackEvent({
    eventName: 'select_banner',
    data: {
      clientId,
      creative_name: data?.title || null,
      banner_id: data?.id || null,
      url: data?.src || null,
    },
  })
}

export default onBannerClickInit
